import { useState, ReactNode, useEffect, useMemo } from "react";
import { ToastContainer, Zoom } from "react-toastify";
import TopNav from "./TopNav";
import { useLocation, matchPath } from "react-router-dom";
import SideNav from "./SideNav";
import { ProductProvider } from "../../context/ProductContext";
import { MPN_PAGES_TITLE } from "../../routes/mpn/helpers/mpnPagesTitle";
import { ARTWORK_PAGES_TITLE } from "../../routes/artwork/helpers/artworkPagesTitle";

interface Props {
  children: ReactNode;
}

const Layout = (props: Props) => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const { children } = props;
  const location = useLocation();

  const [pageTitle, setPageTitle] = useState("Product Mass Update");

  //TODO: MOVE THAT TO A GENERIC FILE AS CONSTANTS
  const titleMap = useMemo(
    () => [
      // { path: "/product-master", title: "Product Master Search" },
      { path: "/product-master", title: "MPN Search" },
      {
        path: "/product-information",
        title: "Product Master - Product Information",
      },
      {
        path: "/product-information/user-guide",
        title: "Product Information - User Guide",
      },
      {
        path: "/product-master/user-guide",
        title: "Product Master Search - User Guide",
      },


      { path: "/placeholder/search", title: "Search Placeholder" },
      { path: "/placeholder/view", title: "Placeholder Information" },

      { path: "/itemnumber/search", title: "Search Item Number" },
      { path: "/itemnumber/view", title: "Item Number Information" },


      { path: "/skus", title: "Search PIS" },
      { path: "/skus/requests", title: "My approval requests" },
      { path: "/mpn/requests", title: "My approval requests" },
      { path: "/tccs/search", title: "Search TCC" },
      { path: "/tccs/requests", title: "Search TCC Request" },
      { path: "/tccs/create", title: "Create TCC Request" },
      { path: "/tccs/view", title: "TCC Information" },
      { path: "/tccs/approvals", title: "My TCC Approvals" },
      { path: "/tccs/*", title: "Tupperware Consumer Code" },
      { path: "/no-access", title: "Session Expired / Not authorized" },
      { path: "/artwork-master", title: "Artwork Master Approval Requests"},
      {
        path: "/artwork-master/collections/create",
        title: "Artwork Master - Create new Collection",
      },
      {
        path: "/artwork-master/collections/*",
        title: "Artwork Master - Collection",
      },
      {
        path: "/artwork-master/artworks/name/create",
        title: "Artwork Master - Create new Meta Artwork",
      }, {
        path: "/artwork-master/artworks/name/*",
        title: "Artwork Master - Meta Artwork",
      },
      {
        path: "/artwork-master/meta-artwork/*",
        title: "Artwork Master - Create new Meta Artwork",
      }, {
        path: "/artwork-master/artworks/number/*",
        title: "Artwork Master - Meta Artwork number",
      },
      {
        path: "/artwork-master/printing-technique/create",
        title: "Artwork Master - Create new Artwork",
      },
      {
        path: "/artwork-master/printing-technique/*",
        title: "Artwork Master - Artwork",
      },
      {
        path: "/artwork-master/search",
        title: "Artwork Master - Search & Edit",
      },

      ...MPN_PAGES_TITLE,
      ...ARTWORK_PAGES_TITLE,

    ],
    [],
  );

  const route = useMemo(
    () => titleMap.find((item) => matchPath(item.path, location.pathname)),
    [location, titleMap],
  );

  useEffect(() => {
    if (route && route.title) {
      setPageTitle(route.title);
      document.title = route.title;
    }
  }, [route]);

  return (
    <div>
      {/* Page Wrapper */}
      <div id="wrapper">
        <ProductProvider>
          <SideNav toggle={toggleMenu} showMenu={showMenu} />

          {/* Content Wrapper */}
          <div
            id="content-wrapper"
            className={`d-flex flex-column ${
              showMenu ? "padding-open" : "padding-collapsed"
            }`}
          >
            {/* Main Content */}
            <div id="content">
              <TopNav toggle={toggleMenu} title={pageTitle} />
              <div id="modal-container" className="pt-1">
                {/* Begin Page Content */}
                <div id="main-content" className="container-fluid">
                  <ToastContainer
                    hideProgressBar
                    newestOnTop
                    draggable={false}
                    theme="colored"
                    transition={Zoom}
                  />
                  {children}
                </div>
              </div>
              {/* /.container-fluid */}
            </div>
            {/* End of Main Content */}

            {/* Footer */}
            <footer className="sticky-footer bg-white">
              <div className="container my-auto">
                <div className="copyright text-center my-auto">
                  <span>Copyright &copy; Tupperware 2024</span>
                </div>
              </div>
            </footer>
            {/* End of Footer */}
          </div>
          {/* End of Content Wrapper */}
        </ProductProvider>
      </div>
      {/* End of Page Wrapper */}
    </div>
  );
};

export default Layout;
